/** @format */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconLocationPinFill,
  homefieldIconArrowOpenInNewOutline,
} from '@dsg-tech/homefield-angular-icons';
import { HomefieldTextLinkComponent } from './text-link.component';

@NgModule({
  imports: [CommonModule, HomefieldIconLibraryModule],
  declarations: [HomefieldTextLinkComponent],
  exports: [HomefieldTextLinkComponent],
})
export class HomefieldTextLinkModule {
  constructor(HomefieldIconsLibraryService: HomefieldIconsLibraryService) {
    HomefieldIconsLibraryService.registerIcons([
      homefieldIconLocationPinFill,
      homefieldIconArrowOpenInNewOutline,
    ]);
  }
}
